import { TableFiltersBar } from '../TableFiltersBar';
import { administratorsFiltersConfig } from '../../utils/tableFilters';
import { COLORS, OrderTypes } from '@/constants';
import { Box, ButtonIcon, ICONS_NAME, Table } from '@servicepipe/ui-components';
import React from 'react';

export const AdministratorsTable = ({
  data,
  loading,
  onPageChange,
  queryParams,
  totalPages,
  totalCount,
  onSortingChange,
  onFiltersChange,
  deleteGroupHandler,
}) => {
  const sortingInitial = {
    id: queryParams.sortKey || '',
    desc: queryParams.sortDirection === OrderTypes.Desc,
  };

  const columns = [
    {
      minWidth: 100,
      width: 100,
      header: 'ID',
      enableSorting: true,
      id: 'partnerClientAccountEmployeeId',
      body: 'partnerClientAccountEmployeeId',
    },
    {
      minWidth: 200,
      header: 'Email',
      id: 'partnerClientAccountEmployee',
      body: ({ row }) => row?.original?.partnerClientAccountEmployee?.email ?? '-',
    },
    {
      header: 'First Name',
      id: 'firstName',
      body: ({ row }) => row?.original?.partnerClientAccountEmployee?.name?.first ?? '-',
    },
    {
      header: 'Last Name',
      id: 'lastName',
      body: ({ row }) => row?.original?.partnerClientAccountEmployee?.name?.last ?? '-',
    },
    {
      id: 'action',
      meta: { justify: 'center', variant: 'action' },
      width: 50,
      minWidth: 50,
      header: '',
      body: ({ row }) => (
        <Box width="100%" justify="flex-end">
          <ButtonIcon
            size="small"
            variant="ghost"
            icon={ICONS_NAME.delete}
            iconColor={COLORS.grayDark}
            onClick={() => deleteGroupHandler(row?.original?.id)}
          />
        </Box>
      ),
    },
  ];

  return (
    <Box direction="column" width="100%" minWidth="0">
      <TableFiltersBar
        filtersConfig={administratorsFiltersConfig}
        queryFilters={queryParams.filters ?? []}
        onFiltersChange={onFiltersChange}
      />

      <Table
        loading={loading}
        data={data}
        columns={columns}
        page={queryParams.page}
        size={queryParams.pageSize}
        totalPages={totalPages}
        totalCount={totalCount}
        onPageChange={onPageChange}
        onSortingChange={onSortingChange}
        initialStateSort={sortingInitial}
      />
    </Box>
  );
};
